import { ToastVariant } from "components/designV2/toast/toast";

export interface Toast {
  readonly id: string;
  readonly message: string;
  readonly variant: ToastVariant;
  readonly title?: string;
  /** Milliseconds the toast is shown, or null to keep it until dismissed. */
  readonly durationMs: number | null;
}

export interface ToastState {
  readonly toasts: readonly Toast[];
}

export type ToastActions =
  | { type: "SHOW_TOAST"; payload: Toast }
  | { type: "DISMISS_TOAST"; payload: { readonly id: string } };

export const initialState: ToastState = {
  toasts: [],
};

export const toastStateReducer = (
  state: ToastState,
  action: ToastActions,
): ToastState => {
  switch (action.type) {
    case "SHOW_TOAST": {
      return { toasts: [action.payload, ...state.toasts] };
    }
    case "DISMISS_TOAST": {
      return {
        toasts: state.toasts.filter((toast) => toast.id !== action.payload.id),
      };
    }
    default: {
      return state;
    }
  }
};
